class DarkrimSeriesTabs extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  connectedCallback() {
    const panelsContainer = this.querySelector('[data-darkrim-series-panels]');
    const tabItems = Array.from(this.querySelectorAll('[data-darkrim-series-tab-item]'));

    if (panelsContainer) {
      tabItems.forEach((tabItem) => {
        const panel = tabItem.querySelector(':scope > [role="tabpanel"]');
        if (panel) panelsContainer.append(panel);
      });
    }

    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
  }

  handleClick(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.contains(tab)) return;

    this.selectTab(this.tabs.indexOf(tab));
  }

  handleKeydown(event) {
    const tab = event.target.closest('[role="tab"]');
    if (!tab || !this.contains(tab)) return;

    const currentIndex = this.tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === currentIndex) return;

    event.preventDefault();
    this.selectTab(nextIndex, true);
  }

  selectTab(index, focus = false) {
    this.tabs.forEach((tab, tabIndex) => {
      const selected = tabIndex === index;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
  }
}

if (!customElements.get('darkrim-series-tabs')) {
  customElements.define('darkrim-series-tabs', DarkrimSeriesTabs);
}
